import dynamic from 'next/dynamic';
import { useRouter } from "next/router";
import BreadCrumbs from "../../src/components/BreadCrumbs";
import { supabase } from "../../lib/supabaseClient";
import { Assets } from "../../src/list/Assets";
import { useEffect, useState, useRef } from "react";

import GridLayout from '../../src/components/GridLayout.js';
import CategoryGames from '../../src/components/CategoryGames.js';
import Headcom from '../../src/components/Headcom.js';
import Ad_320x50 from '../../src/ads/Ad_320x50.js';

const FooterCom = dynamic(() => import('../../src/components/FooterCom'));
const FooterDis = dynamic(() => import('../../src/Description/FooterDis'));

const Snow_fx = dynamic(() => import('../../src/fx/Snow_fx'));
const CommenDis = dynamic(() => import('../../src/Description/CommenDis'));

const CatBtn = dynamic(() => import('../../src/components/CatBtn'));
const BlackScreen = dynamic(() => import('../../src/components/BlackScreen'));
const CookieCom = dynamic(() => import('../../src/components/CookieCom'));

const MobileExitButton = dynamic(() => import('../../src/components/MobileExitButton.js'));

const Ad_300x250_1 = dynamic(() => import('../../src/ads/Ad_300x250_1'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});

const Ad_728x90_Bot = dynamic(() => import('../../src/ads/Ad_728x90_Bot'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});

export async function getStaticPaths() {
  let allSlugs = [];
  let start = 0;
  const limit = 1000;
  let hasMore = true;

  while (hasMore) {
    const { data, error } = await supabase
      .from('bestgamespot_games')
      .select('slug')
      .range(start, start + limit - 1);

    if (error || !data) {
      console.error('Error fetching slugs:', error);
      break;
    }

    if (data.length > 0) {
      allSlugs = [...allSlugs, ...data];
      start += limit;
    } else {
      hasMore = false;
    }
  }

  return {
    paths: allSlugs.map((page) => ({
      params: { id: page.slug },
    })),
    fallback: "blocking",
  };
}

function formatGame(game) {
  return {
    name: [game.game_name || game.title, game.slug],
    path: ['/game/' + game.slug, process.env.NEXT_PUBLIC_BASE_URL || 'https://bestgamespot.com'],
    title: game.title,
    date: game.release_date,
    brand: game.brand,
    hot: game.is_hot ? 'yes' : 'no',
    label: game.label,
    orientation: game.orientation,
    thumb: game.thumb,
    thumb_big: game.thumb_big,
    iframe: game.iframe,
    video: game.video || '',
    Walkthrough: game.walkthrough || '',
    s_dis: game.s_dis,
    l_dis: game.l_dis,
    tag: game.tags || [],
    rating: game.rating || [],
    Details: game.details || {},
    faq: game.faq || []
  };
}

// Slim version — only fields CategoryGames actually renders
function formatGameSlim(game) {
  return {
    name: [game.game_name || game.title, game.slug],
    path: ['/game/' + game.slug],
    hot: game.is_hot ? 'yes' : 'no',
    thumb: game.thumb,
    thumb_big: game.thumb_big,
    video: game.video || '',
  };
}

export async function getStaticProps({ params }) {
  const { data: game, error } = await supabase
    .from('bestgamespot_games')
    .select('*')
    .eq('slug', params.id)
    .single();

  if (error || !game) {
    return { notFound: true };
  }
  
  const { data: popularGames, error: error50 } = await supabase
    .from('bestgamespot_games')
    .select('slug, game_name, title, is_hot, thumb, thumb_big, video')
    .limit(50);

  const { data: categories } = await supabase
    .from('categories')
    .select('*');

  return {
    props: {
      game: formatGame(game),
      first50Games: popularGames ? popularGames.map(formatGameSlim) : [],
      categoriesList: categories || []
    },
    revalidate: 60,
  };
}

export default function GameId({ game, first50Games, categoriesList }) {
  const viewMoreUrls = {};
  for (let i = 1; i <= 2; i++) {
    viewMoreUrls[`Category ${i}`] = `/category-${i}`;
  }
  
  const path = useRouter();
  const pathName = path?.query?.id;
  const [isSmall, setSmall] = useState(false);
  const [mobile, setMobile] = useState(false);
  const mobileBlackScreen = useRef(null);
  const gamePage = useRef(null);
  const mobileView = useRef(null);
  const mobileIframe = useRef(null);
  const mobileMenu = useRef(null);
  const mobileCanvas = useRef(null);
  var catlink;
  var catname;

  catlink =BreadCatLink(game.tag);
  catname =BreadcatName(game.tag);

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Set the default body style
      document.body.style.overflow = "auto";

      const handleResize = () => {
        if (
          window.innerWidth >= 747 &&
          !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          setSmall(false);
        } else {
          setSmall(true);
        }
        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          setMobile(true);
        } else {
          setMobile(false);
        }
      };

      const handleFullscreenChange = () => {
        if (!document.fullscreenElement) {
          // Fullscreen mode has been exited
          mobileExitYes();
        }
      };

      // Add window and document event listeners
      window.addEventListener("resize", handleResize);
      document.addEventListener("fullscreenchange", handleFullscreenChange);
      document.addEventListener("webkitfullscreenchange", handleFullscreenChange); // For Safari
      document.addEventListener("mozfullscreenchange", handleFullscreenChange); // For Firefox
      document.addEventListener("MSFullscreenChange", handleFullscreenChange); // For IE/Edge

      // Handle initial resize
      handleResize();


      // Clean up event listeners on component unmount
      return () => {
        window.removeEventListener("resize", handleResize);
        document.removeEventListener("fullscreenchange", handleFullscreenChange);
        document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
        document.removeEventListener("mozfullscreenchange", handleFullscreenChange);
        document.removeEventListener("MSFullscreenChange", handleFullscreenChange);

      };
    }
  }, []);


  function Sandbox(value) {
    var sand_value;
    if (value == "") {
      // sand_value = "allow-scripts allow-popups allow-same-origin";
    } else {
      // sand_value =
        // "allow-forms allow-pointer-lock allow-popups-to-escape-sandbox allow-same-origin allow-scripts allow-top-navigation-by-user-activation";
    }
    return sand_value;
  }

  function mPlaybtn() {
    gamePage.current.setAttribute("style", "display:none");
    mobileView.current.setAttribute("style", "display:flex");
    mobileIframe.current.src = game.iframe;
    // mobileIframe.current.sandbox = Sandbox(game.brand);
    mobileFullscreen();
  }
  function mobileExit() {
    mobileBlackScreen.current.setAttribute("style", "display:block");
    mobileMenu.current.setAttribute("style", "display:flex");
  }

  function mobileExitNo() {
    mobileBlackScreen.current.setAttribute("style", "display:none");
    mobileMenu.current.setAttribute("style", "display:none");
  }

  function mobileExitYes() {
    mobileBlackScreen.current.setAttribute("style", "display:none");
    mobileMenu.current.setAttribute("style", "display:none");
    gamePage.current.setAttribute("style", "display:block");
    mobileView.current.setAttribute("style", "display:none");
    mobileIframe.current.src = " ";
    ExitmobileFullscreen();
  }


  function ExitmobileFullscreen() {
    if (document.fullscreenElement) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } }
  
  function mobileFullscreen() {
    if (document.fullscreenElement) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } else {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        if (mobileView.current.requestFullscreen) {
          mobileView.current.requestFullscreen({
            navigationUI: "show",
          });
        } else if (mobileView.current.webkitRequestFullscreen) {
          mobileView.current.webkitRequestFullscreen({
            navigationUI: "show",
          });
        } else if (mobileView.current.mozRequestFullScreen) {
          mobileView.current.mozRequestFullScreen({
            navigationUI: "show",
          });
        } else if (mobileView.current.msRequestFullscreen) {
          mobileView.current.msRequestFullscreen({
            navigationUI: "show",
          });
        }

        if (game.orientation == 0) {
          screen.orientation
            .lock("landscape-primary")
            .then(function () {})
            .catch(function (error) {
            });
        } else {
          screen.orientation
            .lock("portrait-primary")
            .then(function () {})
            .catch(function (error) {
            });
        }
      } else {
        if (mobileView.current.requestFullscreen) {
          mobileView.current.requestFullscreen();
        } else if (mobileView.current.webkitRequestFullscreen) {
          mobileView.current.webkitRequestFullscreen();
        } else if (mobileView.current.mozRequestFullScreen) {
          mobileView.current.mozRequestFullScreen();
        } else if (mobileView.current.msRequestFullscreen) {
          mobileView.current.msRequestFullscreen();
        }
      }
    }
  }

  function BreadCatLink(value){
    var link;
    var i;
    var j;
    for(j=0;j<value.length;j++){
      for(i=0;i<categoriesList.length;i++){
         if(categoriesList[i].name==value[j] || categoriesList[i].key_name==value[j]){
           link= categoriesList[i].path[0];
           i=1000; // break the loop
           j=1000; // break the loop
          break;
         }
       }
    }
   return link;
  }

  function BreadcatName(value){
    var link;
    var i;
    var j;
    for(j=0;j<value.length;j++){
      for(i=0;i<categoriesList.length;i++){
         if(categoriesList[i].name==value[j] || categoriesList[i].key_name==value[j]){
           link= categoriesList[i].h1;
           i=1000; // break the loop
           j=1000; // break the loop
           break;
         }
       }
    }
    return link;
  }

  return (
    <>
      <Headcom
        title={game.title}
        s_dis={game.s_dis}
        path={game.path[1] + game.path[0]}
        thumb={game.thumb}
        logo_16={Assets[0].logo_16}
        logo_32={Assets[0].logo_32}
        logo_192={Assets[0].logo_192}
        logo_270={Assets[0].logo_270}
        logo_512={Assets[0].logo_512}
      />
      <div className="app_cont_game">
        <div ref={mobileView} className="mobile-view">
          <div ref={mobileMenu} className="mobile-menu">
            <div className="menu-container">
              <p className="mhead">Quit Game</p>
              <p className="mhead2">Do you Really want to Exit ?</p>
              <div className="yes" onClick={mobileExitYes}>
                <p className="mText">yes</p>
              </div>
              <div className="no" onClick={mobileExitNo}>
                <p className="mText">No</p>
              </div>
            </div>
          </div>
          <div ref={mobileBlackScreen} className="mobile-black_screen"></div>
          <div ref={mobileCanvas} className="mobile-container">
          <MobileExitButton onClick={mobileExit}/>
            <iframe
              ref={mobileIframe}
              className="mobile-canvas"
              height="100%"
              width="100%"
              frameBorder="0"
              scrolling="no"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div ref={gamePage} className="game-page">
          <BlackScreen />
          <div className="game-root">
            <div className="container">
              <div className="grid-container">
              <GridLayout items={viewMoreUrls} mOncliock={mPlaybtn} />
              {mobile && <Ad_300x250_1 />} 
                 {!mobile && <CategoryGames games={first50Games}  />} 
                 {mobile && <CategoryGames games={first50Games}  />} 
                 {mobile && <Ad_320x50 />} 
              </div>
              
            </div>
          </div>
         
          {!mobile &&  <Ad_728x90_Bot />}
          {/* <CatBtn />  */}
          <BreadCrumbs  
          
          catlink={catlink}
          cat={catname}
          link={game.path[0]}
          gamename={game.name[0]}
          gamekey={game.tag}
          />
          <CommenDis
            
            dis={game.l_dis}
            tag={game.tag}
            howto={game.hint}
            video={game.Walkthrough}
          />
        </div>
      </div>
      {/* <FooterDis /> */}
      <FooterCom />
      <Snow_fx />
      <CookieCom />
    </>
  );
}
